import { Grid, CircularProgress } from "@mui/material";

// Loading Component
export const FullPageCircularProgress = () => (
  <Grid
    container
    justifyContent={"center"}
    alignItems={"center"}
    height={"100vh"}
  >
    <CircularProgress size={100} thickness={2} />
  </Grid>
);
